import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import PrivateRoute from './PrivateRoute'; // Import the new PrivateRoute component
import NewOrder from './NewOrder';
import ManageOrders from './ManageOrders';
import ProductManagement from './ProductManagement';
import ReleaseOrder from './ReleaseOrder';
import ReportDashboard from './ReportDashboard';
import UserManagement from './UserManagement';
import Login from './Login';
import Unauthorized from './Unauthorized'; // Page for unauthorized access
import { AppProvider } from './AppContext';
import Shift from './Shift';
import SettingsDashboard from './SettingsDashboard';
import PromotionCodes from './PromotionCodes';
import Profile from './Profile';
import ForgotPassword from './ForgotPassword';
import CreditTopUp from './CreditTopup';
import ViewOrders from './ViewOrders';
import StockManagement from './StockManagement';
import SellPage from './SellPage';
import ViewSales from './ViewSales';
import { Analytics } from "@vercel/analytics/react";
import CreditNotification from './components/CreditNotification';
import ViewStock from './ViewStock';
import LandingPage from './LandingPage';

function App() {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
      <Router>
        <Switch>
          <Route path="/unauthorized" component={Unauthorized} />
          <Route path="/topup" component={CreditTopUp} />
          <Route path="/forgot-password" component={ForgotPassword}/>
          <PrivateRoute path="/newsale" component={SellPage} allowedRoles={['owner','cashier','manager']}/>
          <PrivateRoute path="/viewsales" component={ViewSales} allowedRoles={['owner','cashier','manager']}/>
          <PrivateRoute path="/neworder" component={NewOrder} allowedRoles={['owner','cashier','manager']}/>
          <PrivateRoute path="/vieworders" component={ViewOrders} allowedRoles={['owner','cashier','manager']}/>
          <PrivateRoute path="/manageorders" component={ManageOrders} allowedRoles={['owner', 'operator','manager']}/>
          <PrivateRoute path="/managestock" component={StockManagement} allowedRoles={['owner', 'operator','manager']}/>
          <PrivateRoute path="/viewstock" component={ViewStock} allowedRoles={['owner', 'operator','manager','cashier']}/>
          <PrivateRoute path="/releaseorders" component={ReleaseOrder} allowedRoles={['owner', 'manager','cashier']}/>
          <PrivateRoute path="/shift" component={Shift} allowedRoles={['owner', 'manager','cashier']}/>
          <PrivateRoute path="/products" component={ProductManagement} allowedRoles={['owner', 'manager']}/>
          <PrivateRoute path="/promotion" component={PromotionCodes} allowedRoles={['owner', 'manager']}/>
          <PrivateRoute path="/reports" component={ReportDashboard} allowedRoles={['manager','owner']}/>
          <PrivateRoute path="/users" component={UserManagement} allowedRoles={['owner', 'manager']}/>
          <PrivateRoute path="/settings" component={SettingsDashboard} allowedRoles={['manager','owner']}/>
          <PrivateRoute path="/profile" component={Profile} allowedRoles={['manager','owner','cashier','operator']}/>
          <Route path="/login" component={Login}/>
          <Route exact path="/" component={LandingPage} />
          {/* Add more routes as needed */}
        </Switch>
      </Router>
      </AppProvider>
      <Analytics />
      <CreditNotification />
      {/* Add the Analytics component here */}
    </ThemeProvider>
  );
}

export default App;
